<template>
    <div class="uk-container-expand uk-padding-small uk-clearfix">
        <div class="uk-align-left">
            <checkbox-dropdown :title="agentsTitle" :data="agentsData" @dataIdsChange="selectedAgents" />
            <checkbox-dropdown :title="teamsTitle" :data="teamsData" @dataIdsChange="selectedTeams" />
            <checkbox-dropdown :title="channelsTitle" :data="channelsData" @dataIdsChange="selectedChannels" />
            <checkbox-dropdown :title="tagsTitle" :data="tagsData" @dataIdsChange="selectedTags" />
            <period-dropdown title="Period: " :data="datePeriods" />
            <button
                ref="applyButton"
                type="button"
                :disabled="disableButton"
                class="apply-filter-button uk-button-primary uk-button-small uk-box-shadow-medium uk-text-uppercase uk-text-light uk-border-rounded shadow-color-primary pointer"
                @click="applyFilters"
            >
                Apply
            </button>
        </div>

        <!-- <button
            @click="showAddGraphMenu"
            type="button"
            class="
                uk-button-primary
                uk-button-small
                uk-box-shadow-medium
                uk-text-uppercase
                uk-text-light
                uk-border-rounded
                shadow-color-primary
                uk-align-right
                pointer
                show-graph-menu-button
            "
        >
            Add graph
            <span class="uk-text-medium uk-margin-small-left uk-text-large uk-text-middle">+</span>
        </button> -->

        <add-graph-menu
            v-click-outside="{
                exclude: ['show-graph-menu-button', 'show-graph-box-button'],
                handler: 'hideAddGraphMenu',
            }"
        />
    </div>
</template>

<script lang="js">
import CheckboxDropdown from "./components/CheckboxDropdown.vue";
import PeriodDropdown from "./components/PeriodDropdown.vue";

export default {
    name: "TopBar",
    components: {
        CheckboxDropdown,
        PeriodDropdown,
    },
    data() {
        return {
            agentsTitle: "Agents",
            channelsTitle: "Channels",
            tagsTitle: "Tags",
            teamsTitle: "Teams",
            selectedLabelIds: [],
            selectedAgentIds: [],
            selectedChannelIds: [],
            selectedTagsIds: [],
            selectedTeamsIds: [],
            disableButton: false,
            labelsData: [
                {
                    id: 1,
                    name: "Marketing",
                    active: true,
                },
                {
                    id: 2,
                    name: "VIP",
                    active: false,
                },
            ],
            agentsData: [],
            channelsData: [],
            tagsData: [],
            teamsData: [],
            datePeriods: {
                ["today"]: "Today",
                ["yesterday"]: "Yesterday",
                ["dayBeforeYesterday"]: "Day before yesterday",
                ["thisWeek"]: "This week",
                ["lastWeek"]: "Last week",
                ["thisMonth"]: "This month",
                ["last28Days"]: "Last 28 days",
                ["lastMonth"]: "Last month",
                ["thisYear"]: "This year",
                ["lastYear"]: "Last year",
                ["custom"]: "Custom period",
            },
        };
    },
    beforeMount() {
        // Getting data before mount to fill the filter dropdowns
        this.getAgents();
        this.getChannels();
        this.getTags();
        this.getTeams();
    },
    methods: {
        async logout() {
            if (typeof this.$refs.logoutButton["disabled"] !== "undefined") {
                this.$refs.logoutButton["disabled"] = true;
            }
        },
        showAddGraphMenu() {
            this.$addGraphMenu.show(-1);
        },
        hideAddGraphMenu() {
            this.$addGraphMenu.hide(true);
        },
        selectedLabels(data) {
            this.selectedLabelIds = data;
        },
        selectedAgents(data) {
            this.selectedAgentIds = data;
        },
        selectedChannels(data) {
            this.selectedChannelIds = data;
        },
        selectedTags(data) {
            this.selectedTagsIds = data;
        },
        selectedTeams(data) {
            this.selectedTeamsIds = data;
        },
        getData(endpoint, isResponseObject = false) {
            const dropdownValues = [];

            this.$getData(`https://${process.env.VUE_APP_INSIGHTS_URL}/v1/${endpoint}`).then((result) => {
                for (const i in result.data) {
                    dropdownValues.push({
                        id: isResponseObject
                            ? { value: result.data[i].channel, identifier: result.data[i].identifier }
                            : { value: result.data[i] },
                        name: isResponseObject
                            ? `${result.data[i].channel} ${result.data[i].identifier}`
                            : result.data[i],
                        active: false,
                    });
                }
            });

            return dropdownValues;
        },
        getAgents() {
            const dropdownValues = this.getData("agents");

            dropdownValues.unshift(
                {
                    id: { value: "agents-select-all" },
                    name: "Select all",
                    active: false,
                    defaultLabel: true,
                    toggleAll: true,
                },
                {
                    id: { value: "" },
                    name: "No agent",
                    active: false,
                    defaultLabel: true,
                }
            );

            this.agentsData = dropdownValues;
        },
        getChannels() {
            const dropdownValues = this.getData("channels", true);

            dropdownValues.unshift({
                id: { value: "channels-select-all" },
                name: "Select all",
                active: false,
                defaultLabel: true,
                toggleAll: true,
            });

            this.channelsData = dropdownValues;
        },

        getTags() {
            const dropdownValues = this.getData("tags");

            dropdownValues.unshift(
                {
                    id: { value: "tags-select-all" },
                    name: "Select all",
                    active: false,
                    defaultLabel: true,
                    toggleAll: true,
                },
                {
                    id: { value: "" },
                    name: "No tags",
                    active: false,
                    defaultLabel: true,
                }
            );

            this.tagsData = dropdownValues;
        },

        getTeams() {
            const dropdownValues = this.getData("teams");

            dropdownValues.unshift(
                {
                    id: { value: "teams-select-all" },
                    name: "Select all",
                    active: false,
                    defaultLabel: true,
                    toggleAll: true,
                },
                {
                    id: { value: "" },
                    name: "No teams",
                    active: false,
                    defaultLabel: true,
                }
            );

            this.teamsData = dropdownValues;
        },

        applyFilters() {
            this.disableButton = true;
            this.$store.commit("graphs/applyFilters");
            setTimeout(() => (this.disableButton = false), 5000);
        },
    },
};
</script>
